export default __webpack_public_path__ + "static/media/telegram.fe0de5dc.svg";